if (typeof(window.sassy) === 'undefined') {
  window.sassy = {};

  window.sassy.toast = {
    show: function(message, type = 'success', options = {}) {
      if (typeof(Toastify) === 'undefined') {
        console.warn('Toastify is not ready yet.')
        return;
      }
      
      Toastify({
        text: message,
        duration: 4000,
        close: true,
        stopOnFocus: true, // Prevents dismissing of toast on hover
        style: {
          background: '#088255',
        },
        ...options,
      }).showToast();
    },
  };

  window.sassy.cart = {
    _updateCart: function(data) {
      return fetch(window.theme.routes.cartChange + '?t=' + Date.now(), {
        method: 'POST',
        body: data,
        credentials: 'same-origin',
        headers: {
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest',
          'Accept': 'application/json'
        }
      })
      .then(response => { return response.text() })
      .then(cart => { return cart; });
    },

    _addItems: function(data) {
      return fetch(window.theme.routes.cartAdd + '?t=' + Date.now(), {
        method: "POST",
        body: JSON.stringify(data),
        credentials: "same-origin",
        headers: {
          "Content-Type": "application/json",
          "X-Requested-With": "xmlhttprequest",
        },
      })
    },
      
    addItemFromTrigger: function($el) {
      const $submit = $el;
      const productVariantId = $el.data('product-variant-id');
      const showLoading = $el.data('show-loading') ?? 0;
      const actionAfterAdding = $el.data('action-after') ?? null;
      const data = {
        items: [],
      };

      if ($submit.is(':disabled')) {
        return;
      }
      
      let originalText = $submit.html();
      $submit.attr('disabled', 'disabled');
      if (showLoading) {
        $submit.addClass('btn--loading');
      }

      if (productVariantId) {
        data.items.push({
          id: productVariantId,
          quantity: 1,
        });
      }
      
      if (!data.items.length) {
        $submit.removeAttr('disabled');
        if (showLoading) {
          $submit.removeClass('btn--loading');
        }
        return;
      }

      window.sassy.cart._addItems(data)
        .then(response => { return response.json() })
        .then((response) => {
          switch (actionAfterAdding) {
            case 'redirect-to-cart':
              window.location.href = window.theme.routes.cartPage;
              break;

            case 'redirect-to-checkout':
              window.location.href = '/checkout';
              break;

            default:
              window.sassy.cart.refresh();
              break;
          }
        })
        .catch(error => {
          console.error(error.message);
        })
        .finally(() => {
          $submit.removeAttr('disabled');
          if (showLoading) {
            $submit.removeClass('btn--loading');
          }
        });
    },

    changeItem: function(key, qty, selling_plan) {  
      return window.sassy.cart._updateCart(
        JSON.stringify({
          id: key,
          quantity: qty,
          selling_plan: selling_plan,
        })
      )
    },
    
    removeMembershipItems: async function() {
      const one_month_selling_plan_id = '713137193343';
      const three_month_selling_plan_id = '6834979006';
      
      return Promise.all([
        window.sassy.cart.changeItem('43179795808446', 0, one_month_selling_plan_id),
        window.sassy.cart.changeItem('43179796529342', 0, one_month_selling_plan_id),
        window.sassy.cart.changeItem('43179796889790', 0, one_month_selling_plan_id),
        
        window.sassy.cart.changeItem('43179795808446', 0, three_month_selling_plan_id),
        window.sassy.cart.changeItem('43179796529342', 0, three_month_selling_plan_id),
        window.sassy.cart.changeItem('43179796889790', 0, three_month_selling_plan_id),
      ]);
    },
  
    showAddToCartNotification: function (response) {
      if (!response || !response.items || !response.items.length) {
        console.log('No response can be found', { response });
        return;
      } 

      const itemNames = response.items.map(item => item.title).join(', ');
      window.sassy.toast.show(`${itemNames} has been added to cart`, 'success');
      window.sassy.cart.refresh();
    },

    refresh: function() {
      // This relies on the theme cart refresh
      document.dispatchEvent(new CustomEvent('ajaxProduct:added'));
    },

    init: function() {
      // Triggers
      $(document).on('click', '[data-add-product-trigger]', function(e) {
        e.preventDefault();
        window.sassy.cart.addItemFromTrigger($(this));
      })

      console.log('sassy - cart - init');
    },
  }

  // Initialize
  window.sassy.cart.init();

  // For debugging
  var i = document.createElement('iframe');
  i.style.display = 'none';
  document.body.appendChild(i);
  window.console = i.contentWindow.console;
}